import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from 'antd';

import { VerificationForm } from 'entities/Source';
import { OnboardingText } from 'features/Onboarding';

interface IStepThreeProps extends HTMLAttributes<HTMLDivElement> {}

export const StepThree: FC<IStepThreeProps> = ({ className, ...props }) => {
	const { t } = useTranslation();

	return (
		<Flex {...props} vertical gap={20} className={className}>
			<OnboardingText
				isSteps
				header={t('Подтвердите владение площадкой')}
				text={t('Это необходимо, чтобы вы смогли подавать заявки на оффера рекламодателей.')}
			/>
			<VerificationForm isOnboarding />
		</Flex>
	);
};
